import React, { useState } from "react";
import TextField, { TextFieldProps } from "../../components/TextField";
import VStack from "../../ui_atoms/VStack";
import { ScrollView } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";

type FieldMode = "time" | "decimal" | "text" | "hour";

const StoryComponent = ({
    mode = "text",
    ...fieldProps
}: TextFieldProps & { mode?: FieldMode }) => {
    const [text, setText] = useState("");
    if (mode === "decimal") {
        fieldProps.isDecimalNumber = true;
    } else if (mode === "time") {
        fieldProps.isTime = true;
    } else if (mode === "hour") {
        fieldProps.isHour = true;
    }
    return (
        <ScrollView style={{ width: "100%" }}>
            <VStack gap={0.5} style={{ padding: 10, alignSelf: "stretch" }}>
                <TextField
                    style={{ alignSelf: "stretch" }}
                    value={text}
                    onChangeText={setText}
                    {...fieldProps}
                />
            </VStack>
        </ScrollView>
    );
};

const meta = {
    title: "Fields/Text",
    component: StoryComponent,
    argTypes: {
        disabled: {
            control: {
                type: "boolean",
            },
        },
        placeholder: {
            control: {
                type: "text",
            },
        },
        error: {
            control: {
                type: "text",
            },
        },
        mode: {
            options: ["text", "time", "decimal", "hour"],
            control: { type: "select" },
        },
        left: {
            options: [undefined, "images", "search", "close", "menu", "CHF"],
            control: { type: "select" },
        },
        right: {
            options: [undefined, "images", "search", "close", "menu"],
            control: { type: "select" },
        },
        multiline: {
            control: {
                type: "boolean",
            },
        },
    },
    args: {
        label: "Input something",
        mode: "text",
        right: undefined,
        left: undefined,
        multiline: undefined,
        placeholder: undefined,
    },
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {
        disabled: false,
    },
};

export const Placeholder: Story = {
    args: {
        disabled: false,
        label: undefined,
        placeholder: "I am a placeholder",
    },
};

export const Large: Story = {
    args: {
        disabled: false,
        label: "This is a large label that should be truncated to avoid strange behaviour",
    },
};

export const Decimal: Story = {
    args: {
        disabled: false,
        mode: "decimal",
        label: "Decimal mask",
        maxValue: 1000,
    },
};

export const Hour: Story = {
    args: {
        disabled: false,
        mode: "hour",
        label: "Hour mask",
    },
};

export const Time: Story = {
    args: {
        disabled: false,
        mode: "time",
        label: "Time mask",
    },
};

export const WithError: Story = {
    args: {
        disabled: false,
        error: "This is an error",
    },
};
